var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Component } from 'react';
import { DatePickerAndroid, DatePickerIOS, TouchableOpacity, TouchableWithoutFeedback, View, Text, StyleSheet, Keyboard, } from 'react-native';
import PropTypes from 'prop-types';
import { DRNDateUtil, DRNUtil } from '@traveloka/district-util';
import R from '../../core-res/R';
import DRNInputField from '../InputField';
import DRNModal from '../Modal';
import DRNTouchableWrapper from '../Button/TouchableButtonWrapper';
import { withTheme } from '../../theme';
import { withSmartKey } from '../../smartkey';
class DatePicker extends Component {
    constructor(props) {
        super(props);
        this.handleOpenPicker = () => {
            Keyboard.dismiss();
            if (DRNUtil.isAndroid())
                this.handlePickerAndroid();
            else if (DRNUtil.isiOS())
                this.handlePickerIOS();
            else
                console.warn('Date picker for current Platform is not supported yet');
        };
        this.handlePickerIOS = () => {
            this.setState({ modalVisible: true });
        };
        this.handleSelectDate = date => {
            if (this.props.onSelect)
                this.props.onSelect(date);
        };
        this.handleSelectDateIOS = date => {
            this.handleSelectDate(date);
            this.setState({ modalVisible: false });
        };
        this.handleCancelDatePickerIOS = () => {
            this.setState({ modalVisible: false, date: this.props.date });
        };
        this.dateToString = date => {
            const { formatString, locale } = this.props;
            return DRNDateUtil.dateToString(this.props.date, formatString, { locale });
        };
        const { date, minDate, maxDate } = props;
        let initDate = date;
        if (!initDate) {
            // Default date
            const TODAY = new Date();
            if (minDate && minDate > TODAY)
                initDate = minDate;
            else if (maxDate && maxDate < TODAY)
                initDate = maxDate;
            else
                initDate = TODAY;
        }
        this.state = {
            modalVisible: false,
            date: initDate,
        };
    }
    handlePickerAndroid() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { date, minDate, maxDate, androidMode } = this.props;
                const { action, year, month, day } = yield DatePickerAndroid.open({ date, minDate, maxDate, mode: androidMode });
                if (action !== DatePickerAndroid.dismissedAction) {
                    this.handleSelectDate(new Date(year, month, day));
                }
            }
            catch ({ code, message }) {
                console.warn('Cannot open date picker', message);
            }
        });
    }
    renderDatePickerIOS() {
        const { theme, minDate, maxDate, iosCancelText, iosDoneText } = this.props;
        return (<DRNModal style={{ margin: 0, flex: 1 }} isVisible={this.state.modalVisible} onBackdropPress={this.handleCancelDatePickerIOS} onBackButtonPress={this.handleClose}>
        <View style={{ flex: 1 }}>
          <TouchableWithoutFeedback onPress={this.handleCancelDatePickerIOS}>
            <View style={{ flex: 1 }}/>
          </TouchableWithoutFeedback>
          <View style={[
            styles.iosHeaderDatePicker,
            { backgroundColor: theme.lightNeutral, borderColor: theme.lightNeutral },
        ]}>
            <DRNTouchableWrapper onPress={this.handleCancelDatePickerIOS}>
              <Text style={[styles.iosActionButton, { color: theme.darkPrimary }]}>{iosCancelText}</Text>
            </DRNTouchableWrapper>
            <DRNTouchableWrapper onPress={() => this.handleSelectDateIOS(this.state.date)}>
              <Text style={[styles.iosActionButton, { fontWeight: 'bold', color: theme.darkPrimary }]}>
                {iosDoneText}
              </Text>
            </DRNTouchableWrapper>
          </View>
          <View style={{ backgroundColor: theme.lightSecondary }}>
            <DatePickerIOS date={this.state.date || new Date()} minimumDate={minDate} maximumDate={maxDate} mode={'date'} onDateChange={date => this.setState({ date })}/>
          </View>
        </View>
      </DRNModal>);
    }
    render() {
        return (<View>
        <TouchableOpacity accessible={false} activeOpacity={1.0} onPress={() => this.handleOpenPicker()} disabled={this.props.disabled}>
          <View pointerEvents="none">
            <DRNInputField type="date" value={this.props.date && this.dateToString(this.props.date)} {...this.props}/>
          </View>
        </TouchableOpacity>
        {DRNUtil.isiOS() ? this.renderDatePickerIOS() : null}
      </View>);
    }
}
DatePicker.propTypes = {
    androidMode: PropTypes.oneOf(['default', 'calendar', 'spinner']),
    date: PropTypes.instanceOf(Date),
    formatString: PropTypes.string,
    iosCancelText: PropTypes.string,
    iosDoneText: PropTypes.string,
    locale: PropTypes.string,
    maxDate: PropTypes.instanceOf(Date),
    minDate: PropTypes.instanceOf(Date),
    onSelect: PropTypes.func,
    theme: PropTypes.object,
    disabled: PropTypes.bool,
};
DatePicker.defaultProps = {
    androidMode: 'spinner',
    formatString: 'D MMMM YYYY',
    iosCancelText: 'Cancel',
    iosDoneText: 'Done',
    locale: 'en',
};
const styles = StyleSheet.create({
    iosHeaderDatePicker: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: R.spacing.m,
        borderTopWidth: R.border.width.thick,
    },
    iosActionButton: Object.assign({}, R.typography.uiBaseline),
});
export default withSmartKey(withTheme(DatePicker));
